import { IconUserFilled, IconStarFilled } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n/config";
import { stats } from "@/content/stats";

interface SocialProofProps {
  darkBackground?: boolean;
  className?: string;
  forceBreak?: boolean;
}

const SocialProof = ({ darkBackground = true, className, forceBreak = false }: SocialProofProps) => {
  const { t } = useTranslation();
  const textColorClass = darkBackground ? "text-slate-200" : "text-slate-600";
  const iconColorClass = darkBackground ? "text-yellow-300" : "text-yellow-400";
  const shadedColorClass = darkBackground ? "text-slate-500" : "text-slate-400";

  // Format users count with abbreviation based on language
  const isChinese = i18n.language.indexOf("zh") !== -1;
  const formattedUsers = isChinese
    ? Math.floor(stats.users / 10000) + ' 萬+'
    : Math.floor(stats.users / 1000) + 'k+';

  return (
    <section className={`py-2 ${className || ''}`}>
      <div className="max-w-7xl">
        <div className={`flex flex-col items-start justify-center space-y-2 ${forceBreak ? "" : "lg:flex-row lg:items-center lg:justify-start lg:space-y-0 lg:space-x-4"}`}>
          {/* User Count */}
          <div className="flex flex-row items-center gap-2">
            {/* <IconUserFilled className={`w-4 h-4 ${iconColorClass}`} /> */}
            {/* Overlapping profile images */}
            <div className="flex items-center -space-x-2">
              <img
                src="https://cdn-site.clarymind.com/product-page-app/profile-120/profile-120-3.jpg"
                alt="User"
                className={`w-6 h-6 border border-slate-300 rounded-full object-cover`}
              />
              <img
                src="https://cdn-site.clarymind.com/product-page-app/profile-120/profile-120-1.jpg"
                alt="User"
                className={`w-6 h-6 border border-slate-300 rounded-full object-cover`}
              />
              <img
                src="https://cdn-site.clarymind.com/product-page-app/profile-120/profile-120-2.jpg"
                alt="User"
                className={`w-6 h-6 border border-slate-300 rounded-full object-cover`}
              />
            </div>

            <div className="text-center">
              <div className={`text-sm md:text-base ${textColorClass}`}>{t('socialProof.users', { users: formattedUsers })}</div>
            </div>
          </div>

          {!forceBreak && <div className={`h-4 w-px ${textColorClass} hidden md:block`}></div>}

          {/* Star Rating */}
          <div className="flex flex-row items-center justify-center gap-2">
            <div className="flex items-center space-x-0.5">
              {[...Array(5)].map((_, i) => (
                <IconStarFilled key={i} className={`w-4 h-4 fill-current ${iconColorClass}`} />
              ))}
            </div>

            <div className="text-center">
              <div className={`text-sm md:text-base ${textColorClass}`}>
                {t('socialProof.rating', { rating: stats.rating.average })}
                <span className={`text-xs md:text-sm ${shadedColorClass}`}>
                  &nbsp;&nbsp;({t('socialProof.ratingCount', { ratingCount: stats.rating.count.toLocaleString() })})
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
